
























import { PropType, computed, defineComponent, ref } from '@vue/composition-api';
import { populateVars, currencyWrap } from '../../utils/LegacyUtils';
import { OlbAccordion, OlbAccordionItem } from '../accordion';
import { chunk } from 'lodash';

export default defineComponent({
	components: { OlbAccordion, OlbAccordionItem },

	props: {
		series: {
			type: Array as PropType<any[]>,
			required: true,
		},
        plan: {
            type: Array as PropType<any[]>,
            required: true,
        },
        chunkSize: {
            type: Number,
            default: 10
        },
        headers: {
            type: Object,
            required: true
        }
	},

	setup(props) {
		const tableChunks = computed<any[]>((): Array<any[]> => {
			const originalSeries = (props.series as any[]).slice(1)

			const tableSeries = originalSeries.map((item: any, index: number) => ({
				...item,
				planItem: props.plan[index]
			})) 

			return chunk<Array<any[]>>(tableSeries, props.chunkSize)
		})

		return {
			populateVars,
			currencyWrap,
			tableChunks,
		};
	},
});
